// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__34VzD","savePackageButton":"ClientWallet_savePackageButton__3MU6w"};